/**
 * PublicLocaleGate — route guard for /:locale/* public branches.
 * Unknown "locales" (typos) fall back to the canonical en URL.
 * Split from public-locale.ts so utils stay JSX-free (react-refresh rule).
 */

import { Navigate, Outlet, useParams } from 'react-router-dom'
import { isPublicLocale } from './public-locale'

export function PublicLocaleGate() {
  const { locale } = useParams()
  if (!isPublicLocale(locale)) return <Navigate to="/" replace />
  return <Outlet />
}
